'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Highlight = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateKey(i, value) {
  return 'split-' + i + '-' + value;
}

var Highlight = exports.Highlight = function Highlight(_ref) {
  var cx = _ref.cx,
      value = _ref.value,
      highlightedTagName = _ref.highlightedTagName,
      isHighlighted = _ref.isHighlighted,
      nonHighlightedTagName = _ref.nonHighlightedTagName;

  var TagName = isHighlighted ? highlightedTagName : nonHighlightedTagName;
  var className = isHighlighted ? 'highlighted' : 'nonHighlighted';
  return _react2.default.createElement(
    TagName,
    { className: cx(className) },
    value
  );
};

Highlight.propTypes = {
  cx: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string.isRequired,
  isHighlighted: _propTypes2.default.bool.isRequired,
  highlightedTagName: _propTypes2.default.string.isRequired,
  nonHighlightedTagName: _propTypes2.default.string.isRequired
};

var Highlighter = function Highlighter(_ref2) {
  var cx = _ref2.cx,
      hit = _ref2.hit,
      attribute = _ref2.attribute,
      highlight = _ref2.highlight,
      highlightProperty = _ref2.highlightProperty,
      tagName = _ref2.tagName,
      nonHighlightedTagName = _ref2.nonHighlightedTagName,
      separator = _ref2.separator,
      className = _ref2.className;

  var parsedHighlightedValue = highlight({
    hit: hit,
    attribute: attribute,
    highlightProperty: highlightProperty
  });

  return _react2.default.createElement(
    'span',
    { className: (0, _classnames2.default)(cx(''), className) },
    parsedHighlightedValue.map(function (item, i) {
      if (Array.isArray(item)) {
        var isLast = i === parsedHighlightedValue.length - 1;
        return _react2.default.createElement(
          'span',
          { key: generateKey(i, hit[attribute][i]) },
          item.map(function (element, index) {
            return _react2.default.createElement(Highlight, {
              cx: cx,
              key: generateKey(index, element.value),
              value: element.value,
              highlightedTagName: tagName,
              nonHighlightedTagName: nonHighlightedTagName,
              isHighlighted: element.isHighlighted
            });
          }),
          !isLast && _react2.default.createElement(
            'span',
            { className: cx('separator') },
            separator
          )
        );
      }

      return _react2.default.createElement(Highlight, {
        cx: cx,
        key: generateKey(i, item.value),
        value: item.value,
        highlightedTagName: tagName,
        nonHighlightedTagName: nonHighlightedTagName,
        isHighlighted: item.isHighlighted
      });
    })
  );
};

Highlighter.propTypes = {
  cx: _propTypes2.default.func.isRequired,
  hit: _propTypes2.default.object.isRequired,
  attribute: _propTypes2.default.string.isRequired,
  highlight: _propTypes2.default.func.isRequired,
  highlightProperty: _propTypes2.default.string.isRequired,
  tagName: _propTypes2.default.string,
  nonHighlightedTagName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  separator: _propTypes2.default.node
};

Highlighter.defaultProps = {
  tagName: 'em',
  nonHighlightedTagName: 'span',
  className: '',
  separator: ', '
};

exports.default = Highlighter;


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-dom/dist/cjs/components/Highlighter.js
// module id = 417
// module chunks = 142807904292071